/*
Sohel 11/28/2022 3031450488 Reports map fields reuse search form
Gummala Prakash 11/29/2022 3031450488 Fixed Fields Alignments and Responsiveness.
Ashraf 11/30/2022 3031450488 converting field name to uppercase
Dilip 12/05/2022  3031450488 Removed unecesarry console.log statements
lalitha 12/07/2022 3031450488 added Created By field
Sohel 12/07/2022 3031450488 Repository Name Changes
Poornima 12/07/2022 3031450488 added auto highlight to autocomplete fields
lalitha 12/07/2022 3031450488 fixed page break issue in created by field
Dilip 12/07/2022 3031450488  fixed reset issue
akhila 12/08/2022 3031450488 adding session storage for search items
kavya9reddy 12/09/2022 3031450488 Added createdDate Field
Poornima 12/12/2022 3031450488 added autohighlight for created by field
Suresh Peddavoora 12/13/2022 3031450488 Fixed Responsive Issue Fixes
Rohini 12/27/2022 3031450488 Fixed Buttons Responsive Issue
Ashraf 01/18/2023 3031450488 select field from prompt
kavyareddy 02/07/2023 3031450488 Fixed createdBy dropdown issue
suresh peddavoora 02/21/2023 3031450488 table and textfields alignments
suresh peddavoora 02/27/2023 3031450488 New UI changes
Ravi 03/09/2023 3031450488 Fixed cursor Repository name issue
Prakash 03/16/2023 3031450488 fixed alignments issue in responsive.
Prakash 03/16/2023 3031450488 fixed alignments issue .
Prakash 03/17/2023 3031450488 fixed alignments in Responsive and desktop.
Akhila 06/08/2023 3031450488 created date change to date created field and column
Sohel 09/24/2023 5155351299 new fields added
Sohel 09/24/2023 5155351299 Added Company Look up
Sohel 09/26/2023 5155351299 remove Uppercase Field
Sohel 09/26/2023 5155351299 Company lookup data change and integerated
Sohel 09/26/2023 5155351299 Fixed Payload Issue
Sohel 09/29/2023 5155351299 Fixed Repository Name Search Issue
Sohel 10/01/2023 5155351299 Removed Company Field
uday 10/02/2023 5155351299 fixed button alignmts issues in tab view
Sohel 10/04/2023 5155351299 download configuration payload changes
Sohel 10/07/2023 5155351299 existing repo name search dropdown bug fix
Sohel 11/30/2023 5155351299 Fixed Repository Name First value select Issue
Sohel 12/02/2023 5155351299 Added New Search Field
*/
import React, {useEffect, useState, useContext, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {getBaseCategory, resetData} from '../../../../../redux/reducers/GlobalField/AddFieldList';
import {
  Button,
  TextField,
  FormHelperText,
} from '@material-ui/core';
import {Form, Formik} from 'formik';
import ErrorBoundaryForComponents from '../../../../../util/ErrorBoundaryForComponents';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import FieldListSearchTable from './FieldListSearchTable';
import {WarningSnackbar} from '../../../../../components/CustomSnackBar';
import * as Yup from 'yup';
import SelectTabContextProvider from '../../../../../components/SelectTabContext/SelectTabContext';
import {
  getAllReportCreatedForData,
  fetchCreatedByDropDownData,
} from '../../../../../redux/reducers/ReportMaster';
import {
  fetchExistingDataRepositoryNames,
  resetDataRepo,
  getDropDownData,
  resetBaseRepositoryFields,
} from '../../../../../redux/reducers/GlobalField/DataRepository';
import DateFnsUtils from '@date-io/date-fns';
import {MuiPickersUtilsProvider, KeyboardDatePicker} from '@material-ui/pickers';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import ViewportList from 'react-viewport-list';
import {fetchRole} from '../../../../../redux/reducers/role';
import {createdByOptions} from '../../../../../util/CreatedByForOptions';

const SearchDataRepositories = ({
  setTabValue,
  setFieldListRowData,
  setUsageState,
  usageState,
  setRowSelected,
  setIsCopyData,
  StepperFieldList,
  setShowSearch,
  setFieldListCode,
  fieldList,
  setFieldList,
  isLoading,
  deleteSql,
  setRules,
  rules,
  isReportsFilter,
  isReports,
  sortFields,
  setSortFields,
  selectedRows,
  setFieldValue,
  setSelectedRows,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [searchData, setSearchData] = useState({fieldListCode: fieldList ? fieldList : ''});
  const [submit, setSubmit] = useState(false);
  const [searchFlag, setSearchFlag] = useState(false);
  const {baseCategoryData, fieldListDataUsage} = useSelector(({addFieldList}) => addFieldList);
  const [customError, setCustomError] = useState(false);
  const [usage, setUsage] = useState(false);
  const [deleteUsage, setDeleteUsage] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isUsage, setIsUsage] = useState(false);
  const [userMetrixDelete, setUserMetrixDelete] = useState(false);
  const {setSample} = useContext(SelectTabContextProvider);
  const {createdByData} = useSelector(({reportMaster}) => reportMaster);
  const [nameData, setNameData] = useState();
  const [namePopover, setNamePopover] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const ref = useRef(null);
  const codeRef = useRef();
  const {category} = useSelector(({addRuleGroup}) => addRuleGroup);
  const {allRepositoryNames} = useSelector(({dataRepository}) => dataRepository);
  const filteredCategory = baseCategoryData?.filter((item) => item?.categoryCode !== 'AR');
  const validationSchema = Yup.object().shape({
    createdDate: Yup.date().typeError('Invalid date format').nullable(),
  });
  const repositoryTypeOptions = [{ value: 'Base' }, { value: 'Extended' }];
  const multiRecordOptions = [
    { label: 'Yes', value: 'Y' },
    { label: 'No', value: 'N' },
  ];
  const getCategoryObject = (value, data) => {
    const category = data && data?.filter((i) => i?.categoryCode === value);
    if (category?.length > 0) {
      return category[0];
    }
  };

  useEffect(() => {
    setSearchData({...searchData, fieldListCode: fieldList});
  }, [fieldList]);

  useEffect(() => {
    setSearchData({
      ...searchData,
      baseCategory: category ? getCategoryObject(category, filteredCategory) : {},
    });
  }, [category]);

  // reset data and fetch Base Catagory dropdown data(2700799562)
  useEffect(() => {
    dispatch(resetDataRepo());
    dispatch(resetData());
    dispatch(getBaseCategory());
    dispatch(fetchExistingDataRepositoryNames());
    dispatch(getDropDownData());
    dispatch(fetchRole());
    dispatch(resetBaseRepositoryFields());
    if (!isReports) {
      setRowSelected('');
      setSample(false);
      setIsCopyData(false);
    }
  }, []);

  const getWindowNameData = () => {
    if (allRepositoryNames && allRepositoryNames?.length > 0 && nameData) {
      return allRepositoryNames?.filter((i) =>
        String(i?.repositoryName?.toLowerCase())?.includes(nameData?.toLowerCase()),
      );
    } else {
      return allRepositoryNames?.length > 0 ? allRepositoryNames : [];
    }
  };

  useEffect(() => {
    document.addEventListener('click', (e) => {
      if (!e?.target?.id || e?.target?.id !== 'repoNamePrompt') {
        setNamePopover(false);
      }
    });
    return () => {
      document.removeEventListener('click', () => {});
    };
  }, []);

  // checking there is usage or not(2700799562)
  useEffect(() => {
    if (fieldListDataUsage?.userMetrix === 'No') {
      deleteUsage ? 
        setUserMetrixDelete(false) :
        isDelete ? 
          setCustomError(false) :
          setCustomError(true);
      deleteUsage && setIsDelete(true);
      setTimeout(() => {
        setCustomError(false);
      }, 3000);
    } else if (fieldListDataUsage?.userMetrix === 'Yes') {
      deleteUsage && setIsDelete(true);
      deleteUsage && setUserMetrixDelete(true);
      !isDelete && !deleteUsage && setUsageState(true);
      !isDelete && !deleteUsage && setTabValue(2);
      setUserMetrixDelete(true);
    }
  }, [fieldListDataUsage]);

  // reset state(2700799562)
  useEffect(() => {
    if (!isReports) {
      setUsageState(false);
      setTabValue(0);
      setIsDelete(false);
      setCustomError(false);
    }
  }, []);
  const SearchSessionData = JSON.parse(sessionStorage.getItem('DataRepository'));
  useEffect(() => {
    setSelectedOption(SearchSessionData?.repoName);
  }, []);

  // form initialvalues(2700799562)
  const initialValues = {
    repoName: '',
    repoDescription: '',
    repositoryType: '',
    multiRecord:'',
    tableName: '',
    category: {},
    fieldName: '',
    createdBy: '',
    createdDate: null,
  };

  // set search Data(2700799562)

  const handleSubmit = (values) => {
    setSearchFlag(true);
    setSearchData(values);
    setSubmit(true);
    sessionStorage.setItem('DataRepository', JSON.stringify(values));
  };

  useEffect(() => {
    dispatch(getAllReportCreatedForData());
  }, []);

  useEffect(() => {
    dispatch(fetchCreatedByDropDownData('datarepository'));
  }, [dispatch]);

  const keyPress = (e, setFieldValue) => {
    if (e.key === 'Enter') {
      setFieldValue(
        'repoName',
        // selectedOption ?
        //   selectedOption :
        //   getWindowNameData()[0]?.repositoryName ?
        //     getWindowNameData()[0]?.repositoryName :
        e?.target?.value,
      );
      setSelectedOption(e?.target?.value);
    }
  };

  return (
    // Removed Card styles for text fields (2700799562)
    <div>
      <div className={` mb-0`}>
        <h2 className="search-title">Data Repository Search</h2>
        <Formik
          onSubmit={handleSubmit}
          initialValues={SearchSessionData && !fieldList ? SearchSessionData : initialValues}
          enableReinitialize
          validationSchema={validationSchema}
        >
          {(props) => {
            const {
              values,
              handleChange,
              handleBlur,
              setFieldValue,
              touched,
              errors,
              resetForm,
            } = props;
            return (
              // Changes text field variant from outlined to standard (2700799562)
              <div>
                <Form autoComplete="off" noValidate>
                  <ErrorBoundaryForComponents>
                    <div className="form-row  standard-field-textfields new-standard-textfields">
                      <div className="col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="category"
                          id="category"
                          size="small"
                          disabled={category}
                          value={values.category}
                          options={filteredCategory}
                          autoHighlight
                          getOptionDisabled={(option) => option.categoryCode === ''}
                          getOptionLabel={(option) => {
                            return option && option.categoryName ?
                              option.categoryCode === null ?
                                option.categoryName :
                                option.categoryCode + ' - ' + option.categoryName :
                              '';
                          }}
                          onChange={(e, value) => {
                            setFieldValue('category', value);
                          }}
                          placeholder="Select Category"
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={`${classes.labelName}`}
                                {...params}
                                variant="outlined"
                                margin="dense"
                                name="category"
                                label="Category"
                                placeholder="Select Category"
                              />
                            </div>
                          )}
                        />
                      </div>
                      <div className="col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3  form-group">
                        <TextField
                          id="repoNamePrompt"
                          onClick={() => setNamePopover(!namePopover)}
                          margin="dense"
                          className={`${classes.labelName}`}
                          variant="outlined"
                          placeholder={`Enter Repository Name`}
                          label="Repository Name"
                          name="repoName"
                          onKeyDown={(e) => keyPress(e, setFieldValue)}
                          value={values?.repoName}
                          // InputProps={{
                          //   endAdornment:
                          //     <InputAdornment position="end" className="repo-name"  >
                          //       {<div onclick={() => setNamePopover(true)}> {namePopover ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}</div>}
                          //     </InputAdornment>,
                          // }}
                          onChange={(e) => {
                            // let value = upperCaseName(codeRef);
                            setNamePopover(true);
                            setFieldValue('repoName', e.target.value);
                            if (e.target.value) {
                              setNameData(e?.target?.value);
                            } else if (e.target.value === '') {
                              setNameData('');
                              setSelectedOption('');
                            }
                          }}
                          onBlur={handleBlur}
                          inputRef={codeRef}
                          fullWidth
                          touched={touched.repoName}
                          error={Boolean(touched.repoName && errors.repoName)}
                        />
                        <FormHelperText>
                          {touched.repoName && errors.repoName && errors.repoName}
                        </FormHelperText>
                        {namePopover && getWindowNameData()?.length > 0 && (
                          <div
                            ref={ref}
                            className={`pt-2 pb-2 windowcode-popover Add-trigger-group-popover data-repo-popover-width ${
                              namePopover ? 'popover-open' : ''
                            }`}
                          >
                            {namePopover && (
                              <ViewportList
                                viewportRef={ref}
                                items={getWindowNameData()}
                                itemMinSize={10}
                              >
                                {(item) => (
                                  <div className="data-repo-popover" key={item?.repositoryName}>
                                    <p
                                      className={`${
                                        selectedOption === item?.repositoryName ?
                                          'selected-dropdown-option' :
                                          ''
                                      }`}
                                      onClick={() => {
                                        setFieldValue('repoName', item?.repositoryName);
                                        setSelectedOption(item?.repositoryName);
                                      }}
                                    >
                                      {item?.repositoryName?.replace(/ /g, '\u00a0')}
                                    </p>
                                  </div>
                                )}
                              </ViewportList>
                            )}
                          </div>
                        )}
                      </div>
                      <div className="col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group">
                        <TextField
                          margin="dense"
                          className={`${classes.labelName}`}
                          variant="outlined"
                          placeholder="Enter Repository Description"
                          label="Repository Description"
                          name="repoDescription"
                          value={values.repoDescription}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                        />
                      </div>
                      <div className="col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="repositoryType"
                          size="small"
                          options={repositoryTypeOptions}
                          fullWidth
                          value={values?.repositoryType}
                          onBlur={handleBlur}
                          autoHighlight
                          getOptionLabel={(option) => option?.value || ''}
                          renderInput={(params) => (
                            <GuiTextField
                              className={`${classes.labelName}`}
                              {...params}
                              name="repositoryType"
                              label="Repository Type"
                              variant="outlined"
                              margin="dense"
                              placeholder="Select Repository Type"
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: 'off',
                              }}
                            />
                          )}
                          onChange={(event, value) => {
                            setFieldValue('repositoryType', value);
                          }}
                        />
                      </div>
                      <div className="col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group">
                        <TextField
                          margin="dense"
                          className={`${classes.labelName}`}
                          variant="outlined"
                          placeholder="Enter Table/Repository"
                          label="Table/Repository"
                          name="tableName"
                          value={values.tableName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                        />
                      </div>
                      <div className="col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="multiRecord"
                          size="small"
                          options={multiRecordOptions}
                          fullWidth
                          label="Multi Record"
                          value={values?.multiRecord}
                          onBlur={handleBlur}
                          autoHighlight
                          getOptionLabel={(option) => option?.label || ''}
                          renderInput={(params) => (
                            <GuiTextField
                              className={`${classes.labelName}`}
                              {...params}
                              name="multiRecord"
                              error={Boolean(touched?.multiRecord && errors?.multiRecord)}
                              label="Multi Record"
                              variant="outlined"
                              margin="dense"
                              placeholder="Select Multi Record"
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: 'off',
                              }}
                            />
                          )}
                          onChange={(event, value) => {
                            setFieldValue('multiRecord', value);
                          }}
                        />
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="createdBy"
                          id="createdBy"
                          size="small"
                          value={values.createdBy}
                          options={createdByData || []}
                          getOptionLabel={(option) => {
                            return option && option?.userLoginName ? option?.userLoginName : '';
                          }}
                          renderOption={(option) => {
                            return createdByOptions(option);
                          }}
                          onChange={(e, value) => {
                            setFieldValue('createdBy', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                {...params}
                                variant="outlined"
                                margin="dense"
                                label="Created By"
                                placeholder="Select Created By"
                              />
                            </div>
                          )}
                        />
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            className={`${classes.labelName}`}
                            format="MM/dd/yyyy"
                            placeholder="MM/DD/YYYY"
                            fullWidth
                            value={values.createdDate}
                            name="createdDate"
                            onBlur={handleBlur}
                            inputVariant="outlined"
                            helperText=""
                            label="Date Created"
                            onChange={(val) => {
                              setFieldValue('createdDate', val);
                            }}
                            autoOk
                            margin="dense"
                            touched={touched?.createdDate}
                            error={Boolean(touched?.createdDate && errors?.createdDate)}
                          />
                        </MuiPickersUtilsProvider>
                        <FormHelperText variant="outlined">
                          {touched.createdDate && errors.createdDate ? errors.createdDate : ''}
                        </FormHelperText>
                      </div>
                   
                    </div>
                  </ErrorBoundaryForComponents>
                  <div className="d-flex justify-content-center mb-3 new-standard-textfields">
                    <Button
                      variant="outlined"
                      className={`mr-1 reset-btn`}
                      onClick={() => {
                        setSearchData(initialValues);
                        setSubmit(true);
                        resetForm(initialValues);
                        setNameData('');
                        setSelectedOption('');
                        sessionStorage.removeItem('DataRepository');
                      }}
                    >
                            Reset
                    </Button>
                    <Button type="submit" variant="outlined" className={`ml-1 search-btn`}>
                            Search
                    </Button>
                  </div>
                </Form>
              </div>
            );
          }}
        </Formik>
        <FieldListSearchTable
          searchData={searchData}
          setTabValue={setTabValue}
          searchFlag={searchFlag}
          submit={submit}
          setSubmit={setSubmit}
          setUsage={setUsage}
          usage={usage}
          setFieldListRowData={setFieldListRowData}
          setDeleteUsage={setDeleteUsage}
          setIsDelete={setIsDelete}
          isDelete={isDelete}
          setUsageState={setUsageState}
          usageState={usageState}
          userMetrixDelete={userMetrixDelete}
          setIsUsage={setIsUsage}
          isUsage={isUsage}
          setRowSelected={setRowSelected}
          setUserMetrixDelete={setUserMetrixDelete}
          setIsCopyData={setIsCopyData}
          StepperFieldList={StepperFieldList}
          setShowSearch={setShowSearch}
          setFieldListCode={setFieldListCode}
          setFieldList={setFieldList}
          fieldList={fieldList}
          isReportLoader={isLoading}
          deleteSql={deleteSql}
          isReports={isReports}
          isReportsFilter={isReportsFilter}
          rules={rules}
          setRules={setRules}
          sortFields={sortFields}
          setSortFields={setSortFields}
          selectedRows={selectedRows}
          setFieldValue={setFieldValue}
          setSelectedRows={setSelectedRows}
        />
        {customError && <WarningSnackbar errorMsg={'This Field List is not being used anywhere'} />}
      </div>
    </div>
  );
};

export default SearchDataRepositories;
